import React, { useState, useEffect } from "react";
import "../DepositStyle.css";
import { apiAppFetch, mediatorAppFetch } from '../utils/apiFetch';
import { QRCodeSVG } from 'qrcode.react';
import { PaymentGatewayPayin, fetchPaymentGatewayConfig } from '../modules/paymentGateway';

const Deposit = () => {    
  const [formData, setFormData] = useState({
    name: "",
    userId: "",
    phone: "",
    amount: "",
    paymentMode: "",
    remark: "",
    referenceNumber: "",
  });

  const [bankDetails, setBankDetails] = useState({
    bank: "",
    branch: "",
    accountHolderName: "",
    accountNumber: "",
    IFSC: "",
    aacountType: "",
    upiHandle: ""
  });

  const [showUPIDetails, setShowUPIDetails] = useState(false);
  const [showBankDetails, setShowBankDetails] = useState(false);
  const [amountInWords, setAmountInWords] = useState("");
  const [showUPIMode, setShowUPIMode] = useState(false);
  const [pgConfig, setPgConfig] = useState({
    payinEnabled: false,
    manualDepositEnabled: true,
  });

  const getUserDetails = async () => {
    try {  
      const response = await apiAppFetch('getUserDetails', {
        method: 'POST',
        body: JSON.stringify({}),
      });
      
      const data = await response.json();
      
      setFormData(prevFormData => ({
        ...prevFormData,
        name: data.clientName,
        userId: data.clientId,
        phone: data.phoneNumber
      }));

      if (data.banks && data.banks.length > 0) {
        setBankDetails(data.banks[0]);
        // Check if UPI handle is valid (not 0 or empty)
        setShowUPIMode(data.banks[0].upiHandle && data.banks[0].upiHandle !== "0");
      }

    } catch (error) {
      console.error('Error fetching user details:', error);
    }
  };

  useEffect(() => {
    getUserDetails();
    fetchPaymentGatewayConfig()
      .then((data) => {
        setPgConfig({
          payinEnabled: Boolean(data.payinEnabled),
          manualDepositEnabled: data.manualDepositEnabled !== false,
        });
      })
      .catch(() => {
        setPgConfig({ payinEnabled: false, manualDepositEnabled: true });
      });
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));

    if (name === 'amount') {
      const words = convertToWords(value);
      setAmountInWords(words);
    }
  };

  const convertToWords = (num) => {
    const a = ['','one ','two ','three ','four ', 'five ','six ','seven ','eight ','nine ','ten ','eleven ','twelve ','thirteen ','fourteen ','fifteen ','sixteen ','seventeen ','eighteen ','nineteen '];
    const b = ['', '', 'twenty','thirty','forty','fifty', 'sixty','seventy','eighty','ninety'];
    
    if ((num = num.toString()).length > 9) return 'overflow';
    const n = ('000000000' + num).substr(-9).match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);
    if (!n) return; 
    
    let str = '';
    str += (n[1] != 0) ? (a[Number(n[1])] || b[n[1][0]] + ' ' + a[n[1][1]]) + 'crore ' : '';
    str += (n[2] != 0) ? (a[Number(n[2])] || b[n[2][0]] + ' ' + a[n[2][1]]) + 'lakh ' : '';
    str += (n[3] != 0) ? (a[Number(n[3])] || b[n[3][0]] + ' ' + a[n[3][1]]) + 'thousand ' : '';
    str += (n[4] != 0) ? (a[Number(n[4])] || b[n[4][0]] + ' ' + a[n[4][1]]) + 'hundred ' : '';
    str += (n[5] != 0) ? ((str != '') ? 'and ' : '') + (a[Number(n[5])] || b[n[5][0]] + ' ' + a[n[5][1]]) + 'only ' : '';
    return str;
  };

  const handlePaymentModeChange = (e) => {
    const mode = e.target.value;
    setFormData(prev => ({ ...prev, paymentMode: mode }));

    if (!formData.amount || formData.amount < 1) {
      alert("Please enter valid amount.");
      e.target.value = "";
      return;
    }

    if (mode === "UPI") {
      setShowUPIDetails(true);
      setShowBankDetails(false);
      initiateUPIPayment();
    } else if (mode === "BANK") {
      setShowUPIDetails(false);
      setShowBankDetails(true);
    } else {
      setShowUPIDetails(false);
      setShowBankDetails(false);
    }
  };

  const initiateUPIPayment = () => {
    if (!bankDetails.upiHandle) {
      alert("UPI handle not found. Please contact support.");
      return;
    }

    const upiLink = `upi://pay?pa=${bankDetails.upiHandle}&pn=${bankDetails.accountHolderName}&am=${formData.amount}&cu=INR&tn=Payment for ${formData.userId}`;
    
    // Try to open UPI app directly
    window.location.href = upiLink;
    
    // Fallback for browsers that don't support direct UPI links
    setTimeout(() => {
      const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
      if (isMobile) {
        // For Android
        window.location.href = `intent://pay?pa=${bankDetails.upiHandle}&pn=${bankDetails.accountHolderName}&am=${formData.amount}&cu=INR&tn=Payment for ${formData.userId}#Intent;scheme=upi;package=com.google.android.apps.nbu.paisa.user;end`;
        
        // For iOS
        window.location.href = `tez://upi/pay?pa=${bankDetails.upiHandle}&pn=${bankDetails.accountHolderName}&am=${formData.amount}&cu=INR&tn=Payment for ${formData.userId}`;
      }
    }, 1000);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await mediatorAppFetch({
        method: 'POST',
        body: JSON.stringify({
          submit_cash_entry_client: true,
          transactionTypeRadios: 1,
          toBank: bankDetails.clientId,
          toBankRole: "B",
          toBankName: bankDetails.bank,
          balance_to_add: formData.amount,
          remark: formData.remark + ", Reference: " + formData.referenceNumber,
        }),
      });

      const data = await response.json();
      if (!data.success) {
        alert(data.message);
      } else {
        alert(data.message);
        window.location.reload();
      }
    } catch (error) {
      console.error('Error submitting payment:', error);
      alert("Error submitting payment");
    }
  };

  const showManualDeposit = pgConfig.manualDepositEnabled !== false;

  return (
    <div>
      <PaymentGatewayPayin
        user={{
          clientId: formData.userId,
          clientName: formData.name,
          phoneNumber: formData.phone,
        }}
      />

      {showManualDeposit && (
        <div style={styles.container}>
      <h2 style={styles.heading}>{pgConfig.payinEnabled ? 'Other deposit methods' : 'Payment Deposit Form'}</h2>
      <hr/> <br/>
      <form onSubmit={handleSubmit} style={styles.form}>
        {/* Name & User ID */}
        <div style={styles.row}>
          <div style={styles.inputGroup}>
            <label>Name</label>
            <input type="text" name="name" value={formData.name} readOnly style={styles.inputDisabled} />
          </div>
          <div style={styles.inputGroup}>
            <label>User ID</label>
            <input type="text" name="userId" value={formData.userId} readOnly style={styles.inputDisabled} />
          </div>
        </div>

        {/* Phone */}
        <div style={styles.inputGroup}>
          <label>Phone</label>
          <input type="text" name="phone" value={formData.phone} readOnly style={styles.inputDisabled} />
        </div>

        {/* Amount */}
        <div style={styles.inputGroup}>
          <label>Amount</label>
          <input 
            type="number" 
            name="amount" 
            value={formData.amount} 
            onChange={handleChange} 
            required 
            style={styles.input} 
            min="1"
          />
          {amountInWords && <div style={styles.amountText}>{amountInWords}</div>}
        </div>

        {/* Payment Mode */}
        <div style={styles.inputGroup}>
          <label>Payment Mode</label>
          <select 
            name="paymentMode" 
            value={formData.paymentMode} 
            onChange={handlePaymentModeChange} 
            required 
            style={styles.input}
          >
            <option value="">Select Payment Mode</option>
            {showUPIMode && <option value="UPI">UPI</option>}
            <option value="BANK">Account Transfer</option>
          </select>
        </div>

        {/* Remark */}
        <div style={styles.inputGroup}>
          <label>Remark</label>
          <textarea 
            name="remark" 
            value={formData.remark} 
            onChange={handleChange} 
            style={styles.textarea}
          ></textarea>
        </div>

        {/* Payment Reference Number */}
        <div style={styles.inputGroup}>
          <label>Payment Reference Number</label>
          <input 
            type="text" 
            name="referenceNumber" 
            value={formData.referenceNumber} 
            onChange={handleChange} 
            required 
            style={styles.input} 
          />
        </div>

        {/* Submit Button */}
        <button type="submit" style={styles.button}>Submit</button>
      </form>

      {/* UPI Details */}
      {showUPIDetails && (
        <div style={styles.detailsContainer}>
          <h3>UPI Payment Details</h3>
          <div style={styles.qrContainer}>
            <QRCodeSVG 
              value={`upi://pay?cu=INR&pa=${bankDetails.upiHandle}&pn=${bankDetails.accountHolderName}&am=${formData.amount}`}
              size={200}
            />
            <div style={styles.upiDetails}>
              <p><strong>Receiver's Name:</strong> {bankDetails.accountHolderName}</p>
              <p><strong>Receiver's UPI ID:</strong> {bankDetails.upiHandle}</p>
              <p><strong>Amount:</strong> ₹{formData.amount}</p>
            </div>
          </div>
        </div>
      )}

      {/* Bank Details */}
      {showBankDetails && (
        <div style={styles.detailsContainer}>
          <h3>Bank Details</h3>
          <div style={styles.bankDetails}>
            <div style={styles.row}>
              <div style={styles.inputGroup}>
                <label>Bank</label>
                <input type="text" value={bankDetails.bank} readOnly style={styles.inputDisabled} />
              </div>
              <div style={styles.inputGroup}>
                <label>Branch</label>
                <input type="text" value={bankDetails.branch} readOnly style={styles.inputDisabled} />
              </div>
            </div>
            <div style={styles.inputGroup}>
              <label>Account Holder Name</label>
              <input type="text" value={bankDetails.accountHolderName} readOnly style={styles.inputDisabled} />
            </div>
            <div style={styles.inputGroup}>
              <label>Account Number</label>
              <input type="text" value={bankDetails.accountNumber} readOnly style={styles.inputDisabled} />
            </div>
            <div style={styles.row}>
              <div style={styles.inputGroup}>
                <label>IFSC Code</label>
                <input type="text" value={bankDetails.IFSC} readOnly style={styles.inputDisabled} />
              </div>
              <div style={styles.inputGroup}>
                <label>Account Type</label>
                <input type="text" value={bankDetails.aacountType} readOnly style={styles.inputDisabled} />
              </div>
            </div>
          </div>
        </div>
      )}
        </div>
      )}
    </div>
  );
};

const styles = {
  container: {
    maxWidth: "95%",
    width: "100%",
    margin: "10px auto",
    padding: "20px",
    borderRadius: "10px",
    boxShadow: "0 0 10px rgba(0,0,0,0.1)",
    backgroundColor: "#fff",
    textAlign: "center",
    '@media (min-width: 768px)': {
      maxWidth: "600px",
    }
  },
  heading: {
    color: "#0D2563",
    fontSize: "20px",
    marginBottom: "10px",
    '@media (max-width: 480px)': {
      fontSize: "18px",
    }
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: "15px",
    width: "100%",
  },
  row: {
    display: "flex",
    flexDirection: "column",
    gap: "15px",
    '@media (min-width: 768px)': {
      flexDirection: "row",
      justifyContent: "space-between",
    }
  },
  inputGroup: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    marginBottom: "10px",
  },
  input: {
    padding: "12px",
    borderRadius: "5px",
    border: "1px solid #ccc",
    width: "100%",
    boxSizing: "border-box",
    fontSize: "16px",
    '@media (max-width: 480px)': {
      padding: "10px",
      fontSize: "14px",
    }
  },
  inputDisabled: {
    padding: "12px",
    borderRadius: "5px",
    border: "1px solid #ccc",
    backgroundColor: "#f0f0f0",
    cursor: "not-allowed",
    width: "100%",
    boxSizing: "border-box",
    fontSize: "16px",
    '@media (max-width: 480px)': {
      padding: "10px",
      fontSize: "14px",
    }
  },
  textarea: {
    padding: "12px",
    borderRadius: "5px",
    border: "1px solid #ccc",
    height: "80px",
    width: "100%",
    boxSizing: "border-box",
    fontSize: "16px",
    resize: "vertical",
    '@media (max-width: 480px)': {
      padding: "10px",
      fontSize: "14px",
      height: "60px",
    }
  },
  button: {
    padding: "12px 24px",
    backgroundColor: "#007BFF",
    color: "#fff",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    fontSize: "16px",
    width: "100%",
    marginTop: "10px",
    '@media (min-width: 768px)': {
      width: "auto",
      alignSelf: "center",
    },
    '@media (max-width: 480px)': {
      padding: "10px 20px",
      fontSize: "14px",
    }
  },
  detailsContainer: {
    marginTop: "20px",
    padding: "20px",
    border: "1px solid #ccc",
    borderRadius: "5px",
  },
  qrContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "20px",
    '@media (min-width: 768px)': {
      flexDirection: "row",
      justifyContent: "center",
    }
  },
  upiDetails: {
    textAlign: "left",
  },
  bankDetails: {
    display: "flex",
    flexDirection: "column",
    gap: "15px",
  },
  amountText: {
    marginTop: "5px",
    fontSize: "14px",
    color: "#666",
    textAlign: "left",
  }
};

export default Deposit;
